import React from "react";
import "../css/Loader.css";

function Loader({ visibility = false }) {
  if (!visibility) return null;

  return (
    <div className="loader-overlay">
      {/* Overlay */}
      <div className="loader-overlay-background" />

      {/* Loader Content */}
      <div className="loader-content">
        {/* Animated Book Icon */}
       
        {/* Loading Text */}
        <div className="loader-text">
          <p className="loader-text-title">Loading Knowledge</p>
          <div className="loader-dots-bottom">
            <span className="loader-dot-pulse" />
            <span className="loader-dot-pulse" />
            <span className="loader-dot-pulse" />
            <span className="loader-dot-pulse" />
          </div>
        </div>

        {/* Floating particles */}
        <div className="loader-particles">
          <span className="loader-particle loader-particle-1" />
          <span className="loader-particle loader-particle-2" />
          <span className="loader-particle loader-particle-3" />
          <span className="loader-particle loader-particle-4" />
          <span className="loader-particle loader-particle-5" />
          <span className="loader-particle loader-particle-6" />
          <span className="loader-particle loader-particle-7" />
          <span className="loader-particle loader-particle-8" />
        </div>
      </div>
    </div>
  );
}

export default Loader;